module.exports = __webpack_public_path__ + "img/main_banner.625dfbe8.png";